<template>
  <div class="nettdoc-dropdown">
    <label v-if="showLabel" :style="head || choice ? 'visibility:visible' : 'visibility:hidden'" for="input-field" class="nettdoc-dropdown__toplabel">{{ $t(label) }}</label>
    <template v-if="!isMobile()">
      <div class="nettdoc-dropdown__header" @click="toggleDropdown" :style="head || choice ? 'color: #2c3e50;' : ''">
        {{ $t(head) || $t(choice) || $t(label) }}
        <span v-if="isDropdownActive">
          <img src="../assets/icon-small-arrow-up.svg" />
        </span>
        <span v-else>
          <img src="../assets/icon-small-arrow-down.svg" />
        </span>
      </div>
      <div class="nettdoc-dropdown__list">
        <div
          v-for="(data, index) in data"
          :key="'dropdown_'+data+index"
          class="nettdoc-dropdown__list--item"
          :class="{ 'nettdoc-is-active': isDropdownActive}"
          @click="() => { $emit('action', data); toggleDropdown(data) }"
        >{{ $t(data) }}
        </div>
      </div>
    </template>
    <select 
      v-else 
      v-model="head" 
      @change="e => { $emit('action', e.target.value) }"
      :style="!head && !choice ? 'color:var(--cool-grey)' : ''"
    >
      <label v-if="head || choice" for="input-field">{{ $t(label) }}</label>
      <option disabled :value="null" >{{ $t(head) || $t(choice) || $t(label) }}</option>
      <option 
        v-for="(data, index) in data"
        :key="index"
        :value="data"
      >
        {{ $t(data) }}
      </option>
    </select>
  </div>
</template>

<script>
import detectingMobile from '../mixins/detectingMobile'
export default {
  name: "Dropdown",
  data() {
    return {
      isDropdownActive: false,
      head: null
    };
  },
  props: {
    data: Array,
    label: String,
    choice: String,
    showLabel: Boolean
  },
  mixins:[detectingMobile],
  methods: {
    toggleDropdown: function(head) {
      if (typeof head === 'string') {
        this.head = head
      }
      this.isDropdownActive = !this.isDropdownActive
    }
  }
};
</script>

<style lang="scss" scoped>
.nettdoc-dropdown {
  position: relative;
  box-sizing: border-box;
  padding: 10px 16px;
  select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    border: none;
    width: 100%;
    border: unset;
    border-bottom: 1px solid #cacaca;
    border-radius: initial;
    padding: 10px 0 2px 0 !important;
    font-size: 16px;
    font-weight: 700;
    color: #2c3e50;
    background: url('../assets/icon-small-arrow-down.svg');
    background-repeat: no-repeat, repeat;
    background-position: right 1px top 50%, 0 0;
    background-size: .65em auto, 100%;
  }
  div {
    margin: auto;
    background-color: var(--white);
    text-align: left;
    box-sizing: border-box;
    padding: 10px 0;
    &:hover {
      cursor: pointer;
    }
  }
  span {
    float: right;
    line-height: 1.2;
  }
  &__toplabel {
    text-transform: uppercase;
    color: var(--cool-grey);
    font-weight: bold;
    font-size: 12px;
  }
  &__header {
    position: relative !important;
    box-sizing: border-box !important;
    border-bottom: 1px solid #cacaca;
    font-weight: 700;
    width: 100% !important;
    top: unset !important;
    color: var(--cool-grey);
    font-size: 16px;
    padding-top: 8px !important;
    padding-bottom: 2px !important;
  }
  &__list {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    top: auto;
    margin: 0 !important;
    padding: 0 16px !important;
    padding-top: 0 !important;
    z-index: 900;
    &--item {
      display: none;
      border-bottom: 1px solid #cacaca;
    }
    .nettdoc-is-active {
      display: block;
      &:hover {
        background-color: #f3f3bf !important;
      }
    }
  }
}
</style>